import * as React from 'react'

const Download = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66659 1.89127V5.33338C9.66659 5.80009 9.66659 6.03345 9.75741 6.21171C9.83731 6.36851 9.96479 6.49599 10.1216 6.57589C10.2999 6.66672 10.5332 6.66672 10.9999 6.66672H14.442M5.49992 12.5L7.99992 15M7.99992 15L10.4999 12.5M7.99992 15L7.99992 9.99999M9.66659 1.66666H5.33325C3.93312 1.66666 3.23306 1.66666 2.69828 1.93914C2.22787 2.17882 1.84542 2.56128 1.60574 3.03168C1.33325 3.56646 1.33325 4.26653 1.33325 5.66666V14.3333C1.33325 15.7335 1.33325 16.4335 1.60574 16.9683C1.84542 17.4387 2.22787 17.8212 2.69828 18.0608C3.23306 18.3333 3.93312 18.3333 5.33325 18.3333H10.6666C12.0667 18.3333 12.7668 18.3333 13.3016 18.0608C13.772 17.8212 14.1544 17.4387 14.3941 16.9683C14.6666 16.4335 14.6666 15.7335 14.6666 14.3333V6.66666L9.66659 1.66666Z"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Download
